import user from '@/models/user/effects'
import orders from '@/models/orders/effects'
import socket from '@/models/socket/effects'
import messages from '@/models/messages/effects'
import tenants from '@/models/tenants/effects'
import employee from '@/models/employee/effects'
import managers from '@/models/managers/effects'
import mgroups from '@/models/mgroups/effects'
import notifies from '@/models/notifies/effects'
import productCategory from '@/models/productCategory/effects'
import referrals from '@/models/referrals/effects'
import members from '@/models/members/effects'
import workers from '@/models/workers/effects'
import products from '@/models/products/effects'
import productsPending from '@/models/productsPending/effects'
import configure from '@/models/configure/effects'
import conversations from '@/models/conversations/effects'
import globalSearch from '@/models/globalSearch/effects'
import coupons from '@/models/coupons/effects'
import cashCoupon from '@/models/cashCoupon/effects'
import bonusCoupon from '@/models/bonusCoupon/effects'
import referralRule from '@/models/referralRule/effects'
import taskHall from '@/models/taskHall/effects'
import banner from '@/models/banner/effects'
import { message, Modal } from 'antd';
import * as sagaEffects from 'redux-saga/effects'

const makeWatcher = (actionType, effect) => {
  const [handler, { type }] = Array.isArray(effect)
    ? effect
    : [effect, { type: 'takeEvery' }]
  const sagaHelpers = sagaEffects[type] || sagaEffects.takeEvery

  function* sagaWithCatch(...args) {
    try {
      yield handler(...args.concat(sagaEffects))
    } catch (e) {
      if (!navigator.onLine) {
        return message.error('网络已断开，请检查本地网路')
      }
      const text = e.message || '未知错误，已上报处理'
      if (args[0] && args[0]?.payload?.params?.showModalMessage) {
        Modal.error({
          title: '操作失败',
          content: text,
        });
      } else {
        message.error(text)
      }
      console.info('>>>>>> `saga error`')
      console.error(e)
    }
  }

  return function* () {
    yield sagaHelpers(actionType, sagaWithCatch)
  }
}

const makeSaga = effects =>
  function* () {
    const sagas = Object.keys(effects).map(actionType => {
      const effect = effects[actionType]
      const watcher = makeWatcher(actionType, effect)
      return sagaEffects.fork(watcher)
    })

    yield sagaEffects.all(sagas)
  }

const makeEffects = () =>
  [
    user,
    orders,
    socket,
    messages,
    tenants,
    employee,
    managers,
    notifies,
    mgroups,
    productCategory,
    referrals,
    members,
    workers,
    products,
    productsPending,
    configure,
    conversations,
    globalSearch,
    coupons,
    cashCoupon,
    bonusCoupon,
    referralRule,
    taskHall,
    banner
  ].map(makeSaga)

export default makeEffects
